import React, { useContext, useEffect, useState, useMemo } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Link } from "react-router-dom";
import { Row, Col, Card, Form, Button, Table } from 'react-bootstrap';
import PageLayout from "../../layouts/PageLayout";
import axios from "axios";
import { encode } from 'base-64';
import JoditEditor from 'jodit-react';
import './UserTabularReport';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import moment from 'moment';
import PaginationComponent from "../../components/PaginationComponent";
import { API_URL, APP_PREFIX_PATH } from "../../constant/constant";
import { t } from "i18next";

export default function ConsultationEarningReport() {
    const [userDetails, setUserDetails] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(5);
    const [selectedActions, setSelectedActions] = useState({});
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [fromdateError, setFromDateError] = useState('');
    const [todateError, setToDateError] = useState('');
    const [EqualError, setEqualError] = useState('');

    const entriesPerPage = 5;
    const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    // const currentItems = Array.isArray(userDetails) ? userDetails.slice(indexOfFirstItem, indexOfLastItem) : [];
    const maxDate = moment().format('YYYY-MM-DD');
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const handleActionChange = (index, action, user_id) => {
        setSelectedActions({ ...selectedActions, [index]: action });
        if (action === 'Delete') {

        } else if (action === 'View') {
            // Handle view action if needed
        }
    };

    const fetchUserDetails = () => {
        setUserDetails('')
        setToDateError('');
        setFromDateError('');
        console.log(fromDate, toDate);

        axios
            .post(API_URL + '/consultation_earning_by_date', {

                fromDate: fromDate,
                toDate: toDate

            })
            .then((response) => {
                console.log('res', response.data.consultaionPayment_arr)
                if (response.data.success) {
                    setUserDetails(response.data.consultaionPayment_arr);
                } else {
                    console.error('Error fetching user details:', response.data.msg);
                }
            })
            .catch((error) => {
                console.error('Error fetching user details:', error);
            });
    };

    const handleViewReport = () => {
        let hasError = false;
        if (!fromDate) {
            setFromDateError(t("please_select_from_date"));
            hasError = true;
        } else {
            setFromDateError('');
        }

        if (!toDate) {
            setToDateError(t("please_select_to_date"));
            hasError = true;
        } else {
            setToDateError('');
        }
        if (hasError) {
            return;
        }
        if (toDate < fromDate) {
            setEqualError(t("equal_date"));
            return;
        }


        fetchUserDetails();
    };

    useEffect(() => {
        if (userDetails.length > 0) {
            console.log('First user image:', userDetails[0].image);
        }
    }, [userDetails]);

    const formatDate = (date) => {
        const padTo2Digits = (num) => num.toString().padStart(2, '0');
        const formattedDate = new Date(date);
        const day = padTo2Digits(formattedDate.getDate());
        const month = padTo2Digits(formattedDate.getMonth() + 1);
        const year = formattedDate.getFullYear();
        let hours = formattedDate.getHours();
        const minutes = padTo2Digits(formattedDate.getMinutes());
        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        const strHours = padTo2Digits(hours);

        return `${day}/${month}/${year} ${strHours}:${minutes} ${ampm}`;
    };

    const exportToExcel = () => {
        const ws = XLSX.utils.json_to_sheet(
            userDetails.map((user, index) => {
                const createDateTime = user.createtime

                return {
                    'S. No.': index + 1,
                    'Clinic Name': user.clinic_name,
                    'User Name': user.user_name,
                    'payment': user.payment,
                    'Transaction On': createDateTime
                };
            })
        );
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'ConsultationEarningReport');
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
        saveAs(blob, 'ConsultationEarningReport.xlsx');
    };


    return (
        <PageLayout>
            <Col xl={12}>
                <div className="mc-card">
                    <div className='mc-breadcrumb'>
                        <h3 className="mc-breadcrumb-title">{t('consultaion_earning_report')}</h3>
                        <ul className="mc-breadcrumb-list">
                            <li className="mc-breadcrumb-item"><Link to={`${APP_PREFIX_PATH + '/dashboard'}`} className="mc-breadcrumb-link">{t('home')}</Link></li>
                            <li className="mc-breadcrumb-item">
                                <Link to='#' className="mc-breadcrumb-link">{t('consultation')}</Link>
                            </li>
                            <li className="mc-breadcrumb-item">{t('consultaion_earning_report')}</li>
                        </ul>
                    </div>
                </div>
            </Col>
            <div className="mc-card p-lg-4">

                <Col xl={12}>
                    <Card.Header>
                        <Card.Title as="h5">{t("earning_details")}</Card.Title>
                    </Card.Header><br />
                    <Card.Body>
                        <Form className="flex-wrap">
                            <Row>

                                <Col sm={5} >

                                    <Form.Group className=" ">
                                        <Form.Label className="mb-0">{t("from")}:</Form.Label>
                                        <Form.Control
                                            className="mx-2"
                                            type="date"
                                            max={maxDate}
                                            value={fromDate}
                                            onChange={(e) => { setFromDate(e.target.value); setFromDateError('') }}
                                        />
                                    </Form.Group>
                                    <p style={{ color: 'red', marginLeft: '10px', marginTop: '10px' }}>
                                        {fromdateError}
                                    </p>

                                </Col>

                                <Col sm={5} >
                                    <Form.Group className=" mr-5 mx-0 ">
                                        <Form.Label className="mb-0">{t("to")}:</Form.Label>
                                        <Form.Control
                                            className="mx-2"
                                            type="date"
                                            max={maxDate}
                                            value={toDate}
                                            onChange={(e) => {
                                                setToDate(e.target.value);
                                                setToDateError('')
                                                setEqualError('');
                                            }}
                                        />
                                    </Form.Group>
                                    <p style={{ color: 'red', marginLeft: '24px', marginTop: '10px' }}>
                                        {todateError}
                                    </p>
                                    <p style={{ color: 'red', marginLeft: '24px' }}>{EqualError}</p>

                                </Col>
                                <Col sm={2} >
                                    <Form.Group className="d-inline-flex mx-3" >
                                        <Button className="mb-0 mt-4" onClick={handleViewReport} style={{ width: '150px' }}>
                                            {t("view_report")}
                                        </Button>
                                    </Form.Group>



                                </Col>





                            </Row>
                        </Form>
                    </Card.Body>

                </Col>
            </div>
            <div className="mc-card p-lg-4">

                <Col xl={12}>
                    {userDetails.length > 0 && (
                        <Button variant="success" onClick={exportToExcel} className="mb-3" style={{ backgroundColor: '#5A6268', border: 'none' }}>
                            {t("export_to_excel")}
                        </Button>
                    )}

                    <Card.Body>
                        <Table responsive hover>
                            <thead>
                                <tr>
                                    <th>
                                        <div className="mc-table-check">
                                            <p>{t("sno")}</p>
                                        </div>
                                    </th>
                                    <th>{t("clinic_name")}</th>
                                    <th>{t("user_name")}</th>
                                    <th>{t("payment")}</th>
                                    <th>{t("transaction")}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {userDetails && userDetails.length > 0 ? (
                                    userDetails.slice(indexOfFirstItem, indexOfLastItem).map((item, index) => (
                                        <tr key={index}>
                                            <th scope="row">{indexOfFirstItem + index + 1}</th>

                                            <td>{item.clinic_name || 'NA'}</td>
                                            <td>
                                                <span>{item.user_name || 'NA'}</span>
                                            </td>
                                            <td>{item.payment || 'NA'} $</td>
                                            <td>{item.createtime || 'NA'}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="9" className="text-center">
                                            {t("no_data_available")}
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                        <PaginationComponent
                            totalEntries={userDetails.length}
                            entriesPerPage={entriesPerPage}
                            currentPage={currentPage}
                            onPageChange={handlePageChange}
                        />
                    </Card.Body>
                </Col>
            </div>
        </PageLayout>
    );
}
